export const errorEnum = {
  CONTACTUS: 'contactuserror',
  PAYMENTFAILED: 'paymentfailed',
  NOACCOUNTS: 'noaccounts',
  BILLINGCYCLE: 'billingcycle',
  GENERAL: 'general',
  BIGAMOUNT: 'bigamount',
  LOWAMOUNT: 'lowamount',
  GENERALPRIVATE: 'generalprivate',
  NOACCOUNTSPRIVATE: 'noaccountsprivate',
  CONTACTPRIVATE: 'contactprivate',
  WRONGPAYMENT: 'wrongpayment',
  BITGENERALERROR: 'bitgeneralerror',
  BITPAYMENTFAILED: 'bitpaymentfailed',
  BITPAYMENTIMPOSSIBLE: 'bitpaymentimpossible',
  BITPENDINGPOPUP: 'bitpendingpopup',
  INCORRECTUSER: 'incorrectuser',
};

export const successEnum = {
  CONTACTUS: 'contactussuccess',
  PAYMENTSUCCESS: 'paymentsuccess',
  PAYMENTSUCCESSPRIVATE: 'paymentsuccessprivate',
  BITPENDING: 'bitpending',
};

export const followUpEnum = {
  DifferentPaymentMethod: 'DifferentPaymentMethod',
  PaymentFailed: 'PaymentFailed',
};

export const stepEnum = {
  START: 'start',
  COMPANYSELECT: 'companyselect',
  CONSUMERSELECT: 'consumerselect',
  CONTACTUS: 'contactus',
  CREDITCARD: 'creditcard',
  SELECTAMOUNT: 'selectamount',
  SELECTPAYMENTTYPE: 'selectpaymenttype',
};

export const paymentType = {
  CREDITCARD: 'creditcard',
  BIT: 'bit',
};

export const bitPaymentStatusEnum = {
  NEW: 'new',
  BITPENDING: 'bitpending',
  DONEWITHFU: 'donewithfu',
  DONEWITHERROR: 'donewitherror',
  PAID: 'paid',
  CANCELLED: 'cancelled',
  FAILEDTOCANCEL: 'failedtocancel',
};

export const deviceType = {
  ANDROID: 'Android',
  IOS: 'IOS',
  DESKTOP: 'Desktop',
};
